import { render, staticRenderFns } from "./SuperAdminDashboardNavbar.vue?vue&type=template&id=67e59cb2&"
import script from "./SuperAdminDashboardNavbar.vue?vue&type=script&lang=js&"
export * from "./SuperAdminDashboardNavbar.vue?vue&type=script&lang=js&"
import style0 from "./SuperAdminDashboardNavbar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports